<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-06-30 09:53:33
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <!-- 模板类型（0.自定义模板 1.第一种模板，2.第二种模板，3.第三种模板） -->
    <template v-if="state == 0">
      <upautodtemplete v-if="audatastr != ''" :audatastr="audatastr" :audata="audata"></upautodtemplete>
    </template>
    <template v-if="state == 1">
      <templete1></templete1>
    </template>
    <template v-if="state == 2">
      <form2 :activedetail="activeobj"></form2>
    </template>
    <template v-if="state == 3">
      <templete3></templete3>
    </template>
  </div>
</template>

<script>
import templete1 from "../home/form2/templete1";
import templete3 from "../home/form2/templete3";
import upautodtemplete from "../home/form2/upautodtemplete";
import utils from "@/plugins/utils";
import form2 from "../home/form2/updatetemplete";
import {
  templatetype,
  apply_detail,
  listFormFieldByProjectId,
  selectMetadataTemplateDetail,
} from "@/api/file"; // 接口导入
export default {
  components: {
    form2,
    templete1,
    templete3,
    upautodtemplete,
  },
  computed: {},
  data() {
    return {
      state: 4,
      activeobj: {},
      audatastr: {},
      audata: [],
    };
  },

  created() {},
  mounted() {
    this.getdeils();

    //  this.getteam();
    localStorage.setItem("states", 1);
  },
  methods: {
    // 查询用户已报名详情
    getdeils() {
      let data = {
        applyId: localStorage.getItem("id"),
      };
      apply_detail(data).then((res) => {
        this.audatastr = res.data;
        this.state = res.data.type;
        localStorage.setItem("templateId", res.data.templateId);
        // localStorage.setItem("activityId", res.data.activityId);
        if (res.data.type == 0) {
          this.getauto(res.data.templateId);
        }
      });
    },

    //获取自定义
    getauto(id) {
      listFormFieldByProjectId(id).then((res) => {
        this.audata = res.data;
      });
    },
    returns() {
      this.$router.push("/web/myinfo");
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .el-dialog {
      width: 560px;
      height: 330px;
      border-radius: 12px;
      margin: 0 !important;
      .el-dialog__header {
        background: #24558b;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;

        .el-dialog__title {
          color: white;
        }

        .el-dialog__headerbtn {
          i {
            color: white;
          }
        }
      }

      .el-dialog__body {
        p {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fc524c;
          line-height: 52px;
          text-align: center;
        }

        span {
          display: inline-block;
          width: 100%;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #24558b;
          line-height: 48px;
          text-align: center;
          margin-top: 54px;
        }

        .btnboxs {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 50px;
          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }

        .btnbox {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 20px;

          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }
      }
    }
  }

  .box {
    margin: auto;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    margin-bottom: 42px;

    .el-dialog__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/ .el-dialog {
        width: 560px;
        height: 330px;
        border-radius: 12px;
        margin: 0 !important;
        .el-dialog__header {
          background: #24558b;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;

          .el-dialog__title {
            color: white;
          }

          .el-dialog__headerbtn {
            i {
              color: white;
            }
          }
        }

        .el-dialog__body {
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fc524c;
            line-height: 118px;
            text-align: center;
          }

          span {
            display: inline-block;
            width: 100%;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #24558b;
            line-height: 48px;
            text-align: center;
            margin-top: 54px;
          }

          .btnbox {
            display: flex;
            justify-content: space-evenly;
            width: 59%;
            margin: auto;
            margin-top: 20px;

            button {
              width: 100px;
              height: 42px;
              background: #24558b;
              border-radius: 8px;
              color: #ffffff;
              margin: 0;
              padding: 0;
              border: 1px solid transparent; //自定义边框
              outline: none; //消除默认点击蓝色边框效果
              cursor: pointer;
            }

            .info {
              background: #ffffff;
              border: 1px solid #a6aab8;
              color: #838a9d;
            }
          }
        }
      }
    }

    .header {
      display: flex;
      justify-content: space-between;
      width: 90%;
      margin: 48px 48px;

      .title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3c4353;
      }
    }

    .cont {
      .bottoms {
        width: 100%;
        height: 132px;
        margin-top: 96px;
        box-shadow: 0px 0px 10px 0px rgba(8, 27, 42, 0.1);
        display: flex;
        justify-content: center;

        .el-button {
          height: 42px;
          margin-left: 50px;
          margin-top: 57px;
        }
      }
      .uploadform {
        display: flex;
        height: 60px;
        justify-content: space-between;
        padding-left: 100px;
        padding-right: 100px;
        margin-top: 20px;

        div {
          height: 60px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #167afc;
          line-height: 60px;
          cursor: pointer;
          /deep/ .el-upload-list {
            display: none;
          }
        }
      }
      .part1 {
        .texterar {
          div {
            width: 100%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-textarea {
              min-height: 200px;

              /deep/.el-textarea__inner {
                min-height: 200px !important;
              }
            }
          }
        }

        .listdiv {
          display: flex;
          justify-content: space-between;

          div {
            width: 30%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-input {
              width: 100%;
            }

            .el-select {
              width: 100%;
            }
          }
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;

          /deep/ .el-input-group__prepend {
            border-right: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
          }
        }

        li:nth-child(3) {
          margin-top: 30px;
        }

        li:nth-child(5) {
          margin-top: 30px;
        }

        li:nth-child(7) {
          margin-top: 30px;
        }

        li:nth-child(9) {
          margin-top: 30px;
        }

        li:nth-child(11) {
          margin-top: 30px;
        }
      }

      .part2 {
        .title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #3c4353;
          margin: 48px 48px;
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;

          /deep/ .el-input-group__prepend {
            border-right: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
          }

          .radiobox {
            width: 30%;
            border: 1px solid gainsboro;

            .el-radio {
              margin-left: 30px;
              margin-top: 14px;
            }
          }
        }

        li:nth-of-type(3) {
          margin-top: 30px;
        }

        li:nth-of-type(5) {
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
